<template>
  <div class="studyRecord">
    <van-tabs v-model="tabActive" sticky :offset-top="`${94*$utils.ratio}px`" animated swipeable>
      <van-tab title="课程">
        <van-pullRefresh v-model="page.refreshing" @refresh="onRefresh">
          <Empty v-if="page.totalCount === 0" />
          <van-list
            v-model="page.loading"
            :finished="page.finished"
            @load="onLoad"
            v-else
          >
            <StudyItem v-for="(item,index) in page.list" :key="index" :obj="item"  @click="handleItem(item)" >
              <template v-slot:content>
                <div class="itemSlot">
                  <div class="label">学习进度：</div>
                  <div class="value">{{ item.chapter }} {{ item.annex }}</div>
                </div>
              </template>
            </StudyItem>
            <template #finished>
              <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
            </template>
          </van-list>
        </van-pullRefresh>
      </van-Tab>
      <van-tab title="资源">
        <van-pullRefresh v-model="page.refreshing" @refresh="onRefresh">
          <Empty v-if="page.totalCount === 0" />
          <van-list
            v-model="page.loading"
            :finished="page.finished"
            @load="onLoad"
            v-else
          >
            <StudyItem v-for="(item,index) in page.list" :key="index" :obj="item"  @click="handleItem(item)" >
              <template v-slot:content>
                <div class="itemSlot">
                    <img class="icon" :src="item.fileType === 1?require('@/assets/images/icon_file_01.png'):require('@/assets/images/icon_image_01.png')" />
                    <span class="note">{{ item.fileType === 1?'资源合集':'图片' }}</span>
                </div>
              </template>
            </StudyItem>
            <template #finished>
              <van-divider style="width:50%;margin:20px auto;">滑到底啦</van-divider>
            </template>
          </van-list>
        </van-pullRefresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import StudyItem from './components/StudyItem';
export default {
  name: 'StudyRecord',
  components: { StudyItem },
  data () {
    return {
      tabActive: 0,
      page: {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        totalCount: ''
      }
    };
  },
  watch: {
    tabActive () {
      this.$router.replace({
        query: {
          active: this.tabActive
        }
      });
      this.onRefresh();
    }
  },
  mounted () {
    const { $route } = this;
    this.tabActive = $route.query.active * 1 || 0;
  },
  methods: {
    handleItem ({ id, type }) {
      let tabActive = type - 1;
      if (tabActive === 0 || tabActive === 1) {
        this.$router.push({
          name: 'BookClassDetail',
          query: { id, active: tabActive }
        });
      } else {
        this.$router.push({
          name: 'BookDetail',
          query: { id }
        });
      }
    },
    onLoad () {
      const { page, tabActive } = this;
      const urls = ['record/course', 'record/resource', '', ''];
      const params = {
        pageNo: page.pageNo,
        pageSize: page.pageSize
      };
      if (page.refreshing) {
        page.list = [];
        page.refreshing = false;
      }
      this.$http.get(urls[tabActive], { params, showLoading: true }).then((res) => {
        const { data } = res || {};
        if (!data.isHasNext) {page.finished = true;}
        page.pageNo = data.nextPage;
        page.list.push(...data.result);
        page.loading = false;
        page.totalCount = data.totalCount;
        this.page = page;
      });
    },
    onRefresh () {
      // 清空列表数据 重新加载数据
      this.page = {
        pageNo: 1,
        pageSize: 20,
        list: [],
        loading: true,
        finished: false,
        refreshing: true
      };
      this.onLoad();
    }
  }
};
</script>

<style lang="less" scoped>
.studyRecord {
  background-color: #F7F8FA;
  .itemSlot {
    font-size: 24px;
    font-weight: 400;
    display: flex;
    .label {
      color: #999AAA;
      flex-shrink: 0;
    }
    .value {
      color: #5FA9FF;
    }
    .icon {
      width: 32px;
      height: 32px;
    }
    .note {
      margin-left: 10px;
      font-size: 24px;
      font-weight: 400;
      color: #999AAA;
    }
  }
}
</style>